import script from "./PrivateAllContributions.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivateAllContributions.vue?vue&type=script&setup=true&lang=js"

import "./PrivateAllContributions.vue?vue&type=style&index=0&id=72b35d86&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b35d86"]])

export default __exports__